<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpNavMenuRecommendationCard from '~/components/cp/CpNavMenuRecommendationCard/CpNavMenuRecommendationCard.vue';
  import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
  import type {ILinkGroup} from '~/types';

  defineProps<{
    linkGroups: ILinkGroup[]
  }>();
  const {b, e} = useCpBem('cp-nav-menu-recommendations');
</script>

<template>
    <div :class="b">
        <div v-for="(group, index) in linkGroups" :key="index">
            <div v-for="(recommendation, index2) in group.relatedLinks" :key="index2" :class="e('card')">
                <CpSectionHeader v-if="recommendation.type === 'heading'" :title="recommendation.title" type="h2" show-top-border />
                <CpNavMenuRecommendationCard
                    v-else
                    :name="recommendation.title"
                    :link="recommendation.link"
                    class="px-4"
                />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-recommendations {

    &__card {
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
</style>
